import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './News.css';


const News = () => {
  const [news, setNews] = useState([]);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await axios.get(`https://sneakerxplore.onrender.com/sneaker-news?page=${page}`);
        setNews(response.data); 
      } catch (error) {
        console.error('Error fetching sneaker news:', error);
        setError('Error fetching sneaker news');
      }
    };

    fetchNews();
  }, [page]); // Refetching data when page changes

  const loadNextPage = () => {
    setPage(prevPage => prevPage + 1);
  };

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className='sneaker-news'>
      <h2 className='sneaker-news-heading'>Sneaker News</h2>
      <ul className='news-post'>
        {news.map((item, index) => (
          <li  className='individual-post' key={index}>
            <div className='title-image'>
            <img src={item.image} alt={item.title} />      
            </div>
            <div className='extra-info'>
            <h3 className='news-title'>{item.title}</h3>
            <p>Uploaded:{item.time}</p>
            <p>{item.author_name}</p>
            <p>Author Profile: <a href={item.author_link}>{item.author_name}</a></p>


            <button type='button' className="read-more">
            <a href  ={item.post_link} target="_blank" rel="noopener noreferrer">READ MORE</a>
            </button>
            

            </div>

          </li>
        ))}
      </ul>
      <button  onClick={loadNextPage}>Next</button>
    </div>
  );
};

export default News;
